import React, { useState, useContext } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { FaEnvelope, FaLock, FaSignInAlt, FaEye, FaEyeSlash, FaUser } from 'react-icons/fa'; 
import api from '../api/axios';
import { AppContext } from '../context/AppContext';
import { toast } from 'react-toastify';

const LoginPage = () => {
    const { login } = useContext(AppContext);
    const navigate = useNavigate();
    const location = useLocation();

    // State
    const [formData, setFormData] = useState({ email: '', password: '' });
    const [isLoading, setIsLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false); 

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true); // Mulai Loading

        try {
            // PERBAIKAN 1: Gunakan formData.email dan formData.password
            const response = await api.post('/auth/login', {
                email: formData.email, 
                password: formData.password
            });

            // Panggil fungsi login di context
            login(response.data.user);

            // Redirect berdasarkan role
            const role = response.data.user.role;
            if (role === 'manager') {
                navigate('/manager/dashboard');
            } else {
                navigate('/admin/dashboard');
            }

        } catch (error) {
            // PERBAIKAN 2: Ganti setMsg dengan toast.error
            if (error.response) {
                toast.error(error.response.data.msg);
            } else {
                toast.error("Terjadi kesalahan jaringan");
            }
        } finally {
            setIsLoading(false); // Selesai Loading (Berhenti muter)
        }
    };

    return (
        <div style={styles.pageContainer}>

            {/* Background Decorations */}
            <div style={styles.blobTop}></div>
            <div style={styles.blobBottom}></div>

            <div className="container position-relative z-1 mt-5">
                <div className="row justify-content-center">
                    <div className="col-md-6 col-lg-5">

                        {/* KARTU LOGIN */}
                        <div className="card border-0 shadow-lg animate-fade-in" style={styles.glassCard}>
                            <div className="card-body p-4 p-md-5">

                                {/* Header */}
                                <div className="text-center mb-4">
                                    <h3 className="fw-bold mb-1" style={styles.textGradient}>Selamat Datang</h3>
                                    <p className="text-muted small">Silakan masuk untuk mengelola tim.</p>
                                </div>

                                <form onSubmit={handleSubmit}>

                                    {/* Email / Username Input */}
                                    <div className="mb-3">
                                        <label className="form-label small fw-bold text-secondary ms-1">Email / Username</label>
                                        <div className="input-group">
                                            <span className="input-group-text border-end-0" style={styles.inputIcon}>
                                                <FaUser className="text-primary" />
                                            </span>
                                            <input
                                                type="text" 
                                                name="email"
                                                className="form-control border-start-0 ps-0"
                                                style={styles.inputField}
                                                placeholder="Masukkan Email atau Username"
                                                required
                                                value={formData.email}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </div>

                                    {/* Password Input */}
                                    <div className="mb-4">
                                        <div className="d-flex justify-content-between align-items-center">
                                            <label className="form-label small fw-bold text-secondary ms-1 mb-0">Password</label>
                                            <button
                                                type="button"
                                                className="btn btn-link btn-sm text-decoration-none p-0"
                                                style={{ fontSize: '0.8rem', color: 'var(--primary-color)' }}
                                                onClick={() => toast.info("Hubungi Admin untuk reset password")}
                                            >
                                                Lupa Password?
                                            </button>
                                        </div>

                                        <div className="input-group">
                                            <span className="input-group-text border-end-0" style={styles.inputIcon}>
                                                <FaLock className="text-primary" />
                                            </span>

                                            <input
                                                type={showPassword ? "text" : "password"}
                                                name="password"
                                                className="form-control border-start-0 border-end-0 ps-0"
                                                style={styles.inputField}
                                                placeholder="••••••••"
                                                required
                                                value={formData.password}
                                                onChange={handleChange}
                                            />

                                            <button
                                                type="button"
                                                className="input-group-text border-start-0 bg-transparent"
                                                style={{ cursor: 'pointer', borderTopRightRadius: '1rem', borderBottomRightRadius: '1rem' }}
                                                onClick={() => setShowPassword(!showPassword)}
                                            >
                                                {showPassword ? (
                                                    <FaEyeSlash className="text-muted" />
                                                ) : (
                                                    <FaEye className="text-muted" />
                                                )}
                                            </button>
                                        </div>
                                    </div>

                                    {/* Submit Button */}
                                    <button
                                        type="submit"
                                        className="btn w-100 py-2 shadow-sm mb-3 text-white fw-bold hover-scale"
                                        style={styles.submitBtn}
                                        disabled={isLoading}
                                    >
                                        {isLoading ? (
                                            <>
                                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                Memproses...
                                            </>
                                        ) : (
                                            <>
                                                <FaSignInAlt className="me-2" /> Masuk Aplikasi
                                            </>
                                        )}
                                    </button>
                                </form>

                                {/* Footer Link */}
                                <div className="text-center mt-4 pt-3 border-top border-light">
                                    <p className="small text-muted mb-0">
                                        Belum punya akun tim? <br />
                                        <Link to="/register" className="fw-bold text-decoration-none" style={{ color: 'var(--secondary-color)' }}>
                                            Daftar Sekarang
                                        </Link>
                                    </p>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
};

// ============================================================================
// INTERNAL CSS
// ============================================================================
const styles = {
    pageContainer: {
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
        position: 'relative',
        overflow: 'hidden',
        padding: '2rem 0'
    },
    glassCard: {
        background: 'rgba(255, 255, 255, 0.85)',
        backdropFilter: 'blur(12px)',
        WebkitBackdropFilter: 'blur(12px)',
        borderRadius: '1.5rem',
        border: '1px solid rgba(255, 255, 255, 0.5)',
    },
    textGradient: {
        background: 'var(--primary-gradient)',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
    },
    inputIcon: {
        background: 'white',
        borderTopLeftRadius: '1rem',
        borderBottomLeftRadius: '1rem',
        borderColor: '#e2e8f0'
    },
    inputField: {
        background: 'white',
        borderColor: '#e2e8f0',
        paddingTop: '0.7rem',
        paddingBottom: '0.7rem'
    },
    submitBtn: {
        background: 'var(--primary-gradient)',
        border: 'none',
        borderRadius: '50px', 
    },
    blobTop: {
        position: 'absolute',
        top: '-10%',
        left: '-10%',
        width: '500px',
        height: '500px',
        background: 'radial-gradient(circle, rgba(99,102,241,0.15) 0%, rgba(0,0,0,0) 70%)',
        borderRadius: '50%',
        zIndex: 0,
        filter: 'blur(60px)'
    },
    blobBottom: {
        position: 'absolute',
        bottom: '-10%',
        right: '-10%',
        width: '400px',
        height: '400px',
        background: 'radial-gradient(circle, rgba(244,63,94,0.15) 0%, rgba(0,0,0,0) 70%)',
        borderRadius: '50%',
        zIndex: 0,
        filter: 'blur(60px)'
    }
};

export default LoginPage;